import React from "react";
import { motion } from "framer-motion";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import { socialMediaLinks } from "./projectdata";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { Button, makeStyles } from "@material-ui/core";
import { HashLink as Link } from "react-router-hash-link";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Personimage from "../images/me8.jpg";
const useStyles = makeStyles((theme) => ({
    homepage: {
        display: "flex",
    },
    Home_content_wrap: {
        backgroundColor: "red",
        backgroundColor: "#F4F4F7",
        height: "100%",
        paddingTop: "120px",
        [theme.breakpoints.down("sm")]: {
            paddingTop: "40px",
        },
    },
    Home_content: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column-reverse",
        },
    },
    me: {
        width: "50%",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    image: {
        width: "50%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    socialIcons: {
        marginTop: "50px",
        width: "30%",
        display: "flex",
        justifyContent: "space-between",
        color: "#47484a",
        [theme.breakpoints.down("sm")]: {
            width: "200px",
        },
    },
    icon: {
        color: "#676767",
        transition: "0.3s ease",
        cursor: "pointer",
        "&:hover": {
            color: "#14BDC6",
        },
    },
    my_title: {
        display: "flex",
        flexDirection: "column",
        fontSize: "75px",
        fontWeight: "400",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "row",
            fontSize: "48px",
            marginTop: "50px",
        },
    },
    my_picture: {
        borderRadius: "50%",
        height: "250px",
        width: "250px",
        backgroundImage: `url(${Personimage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",

        [theme.breakpoints.down("sm")]: {
            height: "200px",
            width: "200px",
        },
    },
    scrollDown: {
        height: "60px",
        width: "100%",
        margin: "60px auto ",
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            visibility: "hidden",
            opacity: "0",
            height: "0",
            width: "0",
            margin: "20px ",
        },
    },
    contactMebtn: {
        backgroundColor: " rgb(8 145 153)",
        color: "white",
        transition: "0.3s ease",
        "&:hover": {
            backgroundColor: "teal",
        },
    },
}));
function Home() {
    const classes = useStyles();

    const scrolldownVariants = {
        initial: {
            opacity: 0,
        },
        animationOne: {
            y: [-10, 0],
            opacity: 1,
            transition: {
                delay: 3,

                y: {
                    yoyo: Infinity,
                    duration: 0.5,
                },
            },
        },
    };

    const hi = "HI!";
    const intro = "I'm Anjan,";
    const about =
        "Utilizing meticulous attention to detail and a talent for addressing challenges, I turn client specifications into refined digital solutions. Throughout the entire process, spanning from initial idea to final implementation, I harness my creative abilities to guarantee that each project exceeds anticipated outcomes. My commitment lies in consistently delivering top-tier results that are custom-tailored to meet the distinct requirements of your business.";
    const sentence = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.14,
            },
        },
    };

    const aboutme = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.02,
            },
        },
    };

    const letter = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
        },
    };
    return (
        <div className={classes.homepage} id="home">
            <div className={classes.opening}>
                <div className={classes.Home_content_wrap}>
                    <div className={classes.Home_content}>
                        <div className={classes.me}>
                            <div className={classes.my_title}>
                                <motion.div
                                    variants={sentence}
                                    initial="hidden"
                                    animate="visible"
                                    style={{
                                        marginRight: "20px",
                                        display: "inline-block",
                                    }}
                                >
                                    {hi.split("").map((char, index) => {
                                        return (
                                            <motion.span
                                                key={char + "-" + index}
                                                variants={letter}
                                            >
                                                {char}
                                            </motion.span>
                                        );
                                    })}
                                    {window.visualViewport.width > 900 ? (
                                        <br />
                                    ) : (
                                        " "
                                    )}
                                    {intro.split("").map((char, index) => {
                                        return (
                                            <motion.span
                                                key={char + "-" + index}
                                                variants={letter}
                                            >
                                                {char}
                                            </motion.span>
                                        );
                                    })}
                                </motion.div>
                            </div>

                            <motion.h3
                                style={{ marginTop: "30px" }}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 1.8, duration: 1 }}
                            >
                                A Web3, front-end developer
                            </motion.h3>
                            <motion.p
                                style={{
                                    lineHeight: "30px",
                                    marginBottom: "35px",
                                    marginTop: "10px",
                                }}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 2, duration: 1 }}
                            >
                                {about}
                            </motion.p>
                            <Link
                                smooth
                                to="/#contact_me"
                                style={{ textDecoration: "none" }}
                            >
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 2.5, duration: 1 }}
                                >
                                    <Button
                                        variant="contained"
                                        className={classes.contactMebtn}
                                    >
                                        {" "}
                                        Contact Me
                                    </Button>
                                </motion.div>
                            </Link>
                        </div>

                        <motion.div
                            className={classes.image}
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 1.85,
                                duration: 2,
                                type: "spring",
                                stiffness: "140",
                            }}
                        >
                            <div className={classes.my_picture}></div>

                            <div className={classes.socialIcons}>
                                <a
                                    href={socialMediaLinks.facebook}
                                    target="_blank"
                                >
                                    <FacebookIcon className={classes.icon} />
                                </a>
                                <a
                                    href={socialMediaLinks.linkedin}
                                    target="_blank"
                                >
                                    <LinkedInIcon className={classes.icon} />
                                </a>
                                <a
                                    href={socialMediaLinks.instagram}
                                    target="_blank"
                                >
                                    <InstagramIcon className={classes.icon} />
                                </a>
                                <a
                                    href={socialMediaLinks.github}
                                    target="_blank"
                                >
                                    <GitHubIcon className={classes.icon} />
                                </a>
                            </div>
                        </motion.div>
                    </div>

                    <motion.div
                        className={classes.scrollDown}
                        variants={scrolldownVariants}
                        animate="animationOne"
                        initial="initial"
                    >
                        <div style={{ fontSize: "14px", marginBottom: "0" }}>
                            Scroll Down
                        </div>
                        <KeyboardArrowDownIcon
                            style={{ fontSize: "50px", color: "#089199" }}
                        />
                    </motion.div>
                </div>
            </div>
        </div>
    );
}

export default Home;
